import {
  CLOSE_POPUP,
  LOGIN_USER,
  LOGOUT_USER,
  OPEN_POPUP,
  SET_CURRENT_SCREEN_TYPE,
  SHOW_ACCOUNT_ICON,
} from "../actionType";

export const openAccountPopup = screen => {
  return {
    type: OPEN_POPUP,
    screen,
  };
};

export const closeAccountPopup = () => {
  return {
    type: CLOSE_POPUP,
  };
};

export const setCurrentScreen = screen => {
  return {
    type: SET_CURRENT_SCREEN_TYPE,
    screen,
  };
};

export const logIn = userInfo => {
  return {
    type: LOGIN_USER,
    userInfo,
  };
};

export const logOut = () => {
  return {
    type: LOGOUT_USER,
  };
};

export const showAccountIcon = showIcon => {
  return {
    type: SHOW_ACCOUNT_ICON,
    showIcon,
  };
};
